import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const newsletterRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const form = selector('[data-motion-form]')[0]


  const timeline = gsap.timeline({
    // ...getScrollTriggerOptions(node, reverse),
    ...getScrollTriggerOptions(node, reverse).scrollTrigger,
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let formAnimation: SharedAnimation
  if (form) {
    formAnimation = fadeRevealAnimation(form)
    timeline.add(formAnimation.timeline, 0.15)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    titleAnimation?.revert()
    formAnimation?.revert()
  }
}
